import { cn } from "@/lib/utils";

/**
 * Matches home layout: grid + full-bleed reel on mobile + 9/16 column on lg + 380px suggested.
 * موبايل: نفس `MainHomePage` — ارتفاع svh، بدون padding أفقي، بدون aspect على الريل.
 */
export default function VideoFeedPageSkeleton() {
  return (
    <div
      className={cn(
        "skeleton-stage mx-auto grid min-h-0 w-full max-w-screen grid-cols-1 grid-rows-1 place-items-center gap-6 px-4",
        "max-lg:flex max-lg:min-h-0 max-lg:flex-1 max-lg:max-w-none max-lg:gap-0 max-lg:px-0",
        "max-lg:h-[calc(100svh-65px-env(safe-area-inset-bottom,0px))]",
        "max-lg:max-h-[calc(100svh-65px-env(safe-area-inset-bottom,0px))]",
        "lg:grid lg:grid-cols-2 lg:h-[calc(100vh-104px)] lg:max-h-[calc(100vh-104px)] lg:w-auto lg:max-w-7xl",
      )}
      aria-busy
      aria-label="Loading"
    >
      <div className="relative col-span-2 h-full min-h-0 w-full max-lg:flex-1 lg:col-span-1 lg:flex lg:justify-end">
        <div
          className={cn(
            "relative h-full min-h-0 w-full max-lg:max-h-full",
            "lg:ms-auto lg:aspect-[9/16] lg:h-[min(100%,calc(100vh-104px))] lg:max-h-[calc(100vh-104px)] lg:w-auto lg:min-h-[320px] lg:shrink-0",
          )}
        >
          {/* Gradient overlay strip (VideoFeedWithTabs) */}
          <div className="pointer-events-none absolute left-0 right-0 top-4 z-30 h-16 max-lg:top-0 max-lg:rounded-none rounded-t-2xl bg-gradient-to-b from-muted/80 to-transparent" />
          {/* Tab strip placeholder */}
          <div className="absolute left-1/2 top-4 z-40 flex h-16 max-lg:top-0 max-lg:rounded-none -translate-x-1/2 items-center justify-center gap-4 rounded-t-2xl px-2 sm:gap-6">
            <div className="h-4 w-14 max-w-[22%] rounded skeleton-shimmer sm:w-16" />
            <div className="h-4 w-10 max-w-[18%] rounded skeleton-shimmer sm:w-12" />
            <div className="h-4 w-12 max-w-[20%] rounded skeleton-shimmer sm:w-14" />
          </div>
          {/* Video area — موبايل: بدون pt وزوايا كاملة العرض */}
          <div className="h-full max-lg:pt-0 pt-4">
            <div className="h-full max-lg:rounded-none overflow-hidden rounded-t-2xl skeleton-shimmer opacity-95" />
          </div>
          {/* CardActions rail — matches CardActions positioning */}
          <div className="absolute bottom-28 end-2 z-30 flex w-10 flex-col gap-2 items-center max-lg:bottom-28 lg:bottom-0 lg:end-0 lg:ms-4 lg:start-full">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="h-9 w-9 shrink-0 rounded-full skeleton-shimmer sm:h-10 sm:w-10"
              />
            ))}
          </div>
        </div>
      </div>

      <div className="hidden lg:flex flex-col py-4 h-full w-[380px] min-h-0 shrink-0">
        <div className="h-7 w-48 skeleton-shimmer rounded-md mb-4 shrink-0" />
        <div className="flex flex-col gap-4 flex-1">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3 min-w-0">
                <div className="h-12 w-12 rounded-full skeleton-shimmer shrink-0" />
                <div className="flex flex-col gap-2 min-w-0">
                  <div className="h-4 w-32 skeleton-shimmer rounded" />
                  <div className="h-3 w-24 skeleton-shimmer rounded" />
                </div>
              </div>
              <div className="h-8 w-20 rounded-full skeleton-shimmer shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
